import script from "./Download.vue?vue&type=script&lang=ts&setup=true"
export * from "./Download.vue?vue&type=script&lang=ts&setup=true"

import "./Download.vue?vue&type=style&index=0&id=632bb44e&lang=less"

const __exports__ = script;

export default __exports__